<template>
  <div class="management-contract">
    <el-form ref="form" :model="filtersForm" label-width="80px" inline>
      <el-form-item label="处方单号">
        <el-input v-model="filtersForm.orderNo" placeholder="请输入处方单号"></el-input>
      </el-form-item>
      <el-form-item label="患者姓名">
        <el-input v-model="filtersForm.compatName" placeholder="请输入患者姓名"></el-input>
      </el-form-item>
      <!-- <el-form-item label="申请日期">
       <el-date-picker
       v-model="daterange"
       type="daterange"
       value-format="yyyy-MM-dd"
       range-separator="-"
       start-placeholder="开始日期"
       end-placeholder="结束日期"
       &gt;</el-date-picker>
       </el-form-item>-->
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <el-radio-group v-model="checkedStatus">
      <el-radio-button v-for="state in states" :label="state.label" :key="state.text">
        {{ state.text }} ({{ state.num }})
      </el-radio-button>
    </el-radio-group>
    <el-table :data="list" v-loading="loading" border :cell-class-name="cellRedShow">
      <el-table-column prop="orderNo" label="处方单号" align="center" width="120"></el-table-column>
      <el-table-column prop="status" :formatter="formatterStatus" label="处方状态" align="center"
                       width="80"></el-table-column>
      <el-table-column prop="orderType" :formatter="formatterType" label="处方类型" align="center"
                       width="80"></el-table-column>
      <el-table-column prop="compatName" label="患者" align="center" width="100"></el-table-column>
      <el-table-column prop="compatGender" label="性别" :formatter="formatterSex" align="center"
                       width="50"></el-table-column>
      <el-table-column prop="compatAge" label="年龄" align="center" width="50"></el-table-column>
      <el-table-column prop="diagnosis" label="诊断" align="center" min-width="150"></el-table-column>
      <el-table-column prop="docName" label="开方医生" align="center" width="100"></el-table-column>
      <el-table-column v-if="checkedStatus!=='ISSUE'"
                       prop="auditorName" label="审方医生" align="center" width="100">
        <template slot-scope="scope">{{ scope.row.auditorName || '—' }}</template>
      </el-table-column>
      <el-table-column v-if="checkedStatus!=='ISSUE'&& checkedStatus!=='RECALL'"
                       prop="refuseReason" min-width="150" label="拒绝理由"
                       align="center">
        <template slot-scope="scope">{{ scope.row.refuseReason || '—' }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="开方时间" width="140" align="center">
        <template slot-scope="scope">{{ scope.row.createDate|getTime }}</template>
      </el-table-column>
      <el-table-column v-if="checkedStatus!=='ISSUE'" prop="auditTime" label="审方时间" width="140" align="center">
        <template slot-scope="scope">{{ scope.row.auditTime|getTime }}</template>
      </el-table-column>
      <!--<el-table-column prop="returnCount" label="被退回记录" align="center"></el-table-column>-->
      <el-table-column label="操作" width="260" fixed="right">
        <template slot-scope="scope">
          <el-button @click.prevent="showCheckDialog(scope.row.id)"
                     v-if="['CANCEL','PAY','SHIPPING','COMPLETE','COMMENT','WAITTAKE'].includes(scope.row.status)"
                     type="primary" size="small">查看详情
          </el-button>
          <el-button v-if="scope.row.status === 'RECALL'"
                     :disabled="scope.row.reopenFlag"
                     :type="scope.row.reopenFlag? 'info':'primary'"
                     @click.prevent="goToEPrescription(scope.row.id,'sub', scope.row)"
                     size="small">
            {{ scope.row.reopenFlag ? '已 重 开' : '重新开方' }}
          </el-button>
          <el-button v-if="scope.row.status === 'REFUSE'"
                     :disabled="scope.row.reopenFlag"
                     :type="scope.row.reopenFlag? 'info':'primary'"
                     @click.prevent="goToEPrescription(scope.row.id,'sub', scope.row)"
                     size="small">
            {{ scope.row.reopenFlag ? '已 重 开' : '重新开方' }}
          </el-button>
          <el-button v-if="['ISSUE','AUDIT'].includes(scope.row.status)"
                     @click.prevent="reCall(scope.row.id,scope.row.status)"
                     type="primary" size="small">召回处方
          </el-button>
          <el-button v-if="scope.row.status !== 'RECALL'||
                                (scope.row.status === 'RECALL' && scope.row.reopenFlag)"
                     @click.prevent="goToEPrescription(scope.row.id, 'reSub', scope.row)"
                     type="primary" size="small">查看处方
          </el-button>
          <!--<el-button @click.prevent="doPrint(scope.row.recipePdfUrl, 'reSub')"-->
          <!--type="primary" size="small">打印-->
          <!--</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <el-row class="pagination-wrapper" type="flex" justify="end">
      <el-pagination
          layout="prev, pager, next"
          :current-page.sync="page.pageNum"
          :total="page.total"
          @current-change="onCurrentChange"
      ></el-pagination>
    </el-row>
    <check-dialog ref="checkDialog" :info="orderInfo"></check-dialog>
    <recipe-preview ref="preview" :info="previewInfo" :drugs="previewInfo.drugList"></recipe-preview>
    <EPrescription ref="drawerRecipe"
                   :info="recipeInfo"
                   source="PrescriptionList"
                   :orderDetail="orderDetail"
    ></EPrescription>
  </div>
</template>

<script>
import {MessageBox, Message} from 'element-ui'
import {tokenCache} from "../../lib/cache/Token"
import {timeFormat} from "ty-vue-filters";
import {sexFilter} from "../../lib/filters";
import CheckDialog from "../../components/prescription/check-dialog"
import {recipeService} from "../../lib/service/recipe";
import RecipePreview from "../../components/prescription/recipe-preview";
import EPrescription from "./EPrescription";
import {RECIPE_TYPE} from "@/lib/config";

const PAGE = {
  pageNum: 1,
  pageSize: 10,
  pages: 1,
  total: 0
};
export default {
  data() {
    return {
      daterange: [],
      filtersForm: {
        orderNo: "",
        patName: "",
      },
      list: [],
      states: [
        {
          label: "ISSUE",
          text: "审核中",
          numName: 'issueRecipeCount',
          num: 0,
        },
        {
          label: "REFUSE",
          text: "审核拒绝",
          numName: 'refuseAllRecipeCount',
          num: 0,
        },
        {
          label: "RECALL",
          text: "已召回",
          numName: 'recallRecipeCount',
          num: 0,
        },
        {
          label: "",
          text: "全部处方",
          numName: 'allRecipeCount',
          num: 0,
        },
      ],
      loading: false,
      page: PAGE,
      checkedStatus: 'ISSUE',
      orderInfo: {},
      previewInfo: {},
      recipeInfo: {},
      orderDetail: {}
    };
  },
  components: {EPrescription, RecipePreview, CheckDialog},
  watch: {
    daterange(val) {
      this.filtersForm.startDate = val ? val[0] : "";
      this.filtersForm.endDate = val ? val[1] : "";
    },
    checkedStatus: {
      handler() {
        this.pages = PAGE;
        this.getOrderCount()
        this.getList();
      },
      immediate: true
    }
  },
  filters: {
    getTime(str) {
      if (!str) return '—'
      return timeFormat(str, "%Y/%m/%d %H:%M")
    }
  },
  methods: {
    timeFormat,
    /**
     * 获取头部
     * @returns {Promise<void>}
     */
    async getOrderCount() {
      let {obj} = await this.$http("smarthos.recipe.order.nohandle.count");
      console.log(obj)
      this.states.forEach((item, index) => {
        this.states[index].num = obj[item.numName]
      })
    },
    cellRedShow(row, column, rowIndex, columnIndex) {
      if (row.column.label == '拒绝原因') {
        return 'color_red'
      }
    },
    //reSub-查看开方 sub-重新开方
    async goToEPrescription(id, handle, row) {
      if (handle === 'reSub') {
        let obj = await recipeService.info(row.id)
        if (Object.values(obj).length > 0) {
          this.previewInfo = obj
          this.$refs.preview.show()
        }
      }
      // sub-重新开方
      else {
        this.orderDetail = row
        this.recipeInfo = {
          rpId: row.id,
          hosId: row.hosId,
          type: row.orderType,
          bizType: row.bizType,
          bizId: row.bizId,
          ddId: row.bizId,
          handle: 'sub',
        }
        this.$refs.drawerRecipe.show()
      }
      console.log(handle, row)

      /* this.$router.push({
             path: "/main/e-prescription",
             query: {
                 rpId: id,
                 bizId: row.bizId,
                 handle: handle,
                 hosId: row.hosId,
                 bizType: row.bizType,
                 type: row.orderType
             }
         });*/
    },
    async reCall(id, status) {
      let tip = status == 'ISSUE' ? '您的处方即将审核，是否召回？' : '您的处方已审核通过，是否仍要召回？'
      MessageBox.confirm(tip, '请注意！', {
        confirmButtonText: '确定召回',
        cancelButtonText: '再考虑下',
        type: 'warning'
      }).then(async () => {
        let options = {
          token: tokenCache.get(),
          orderId: id
        };
        let res = await this.$http("smarthos.recipe.order.recall", options);
        if (res.code == 0) {
          Message({
            showClose: true,
            message: "操作成功",
            type: "success"
          });
          this.getList();
          this.getOrderCount()
        }
      }).catch(() => {
      });
    },
    onSubmit() {
      this.getList();
    },
    async showCheckDialog(id) {
      const obj = await recipeService.info(id)
      if (Object.values(obj).length > 0) {
        this.orderInfo = obj
        console.log(this.orderInfo)
        this.$refs.checkDialog.show()
      }
    },

    onCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const options = {
        status: this.checkedStatus,
        token: tokenCache.get(),
        ...this.page,
        ...this.filtersForm
      }
      const {code, list, page, msg} = await this.$http('smarthos.recipe.order.opendoc.list.page', options)
      if (code === "0") {
        this.loading = false;
        this.$set(this, 'list', list)
        this.page = page;
      } else {
        this.$message.error(msg);
      }
    },
    formatterTime(row, column, time) {
      return time ? timeFormat(time, "%Y/%m/%d %H:%M") : '—';
    },
    formatterSex(row, column, sex) {
      return sexFilter(sex, 1);
    },
    formatterType(row, column, code) {
      const orderType = RECIPE_TYPE
      return orderType[code]
    },

    formatterStatus(row, column, code) {
      const statusObj = {
        RECALL: "已召回",
        REFUSE: "审核拒绝",
        WAIT_SIGN: '待签名',
        ISSUE: "审核中",
        AUDIT: "待支付",
        WAITTAKE: "待取药",
        WAITSHIP: '待取药',
        SHIPPING: "待取药",
        TAKING: '待取药',
        COMPLETE: "已完成",
        CANCEL: "已作废",
      };
      return statusObj[code];
    },
    doPrint(url) {
      window.open(url);
    }
  }
};
</script>

<style lang="scss">
.management-contract {
  .el-form {
    padding-top: 22px;
    border-top: 1px solid #f5f5f5;
  }

  .el-table {
    margin-top: 15px;
  }

  .pagination-wrapper {
    padding: 20px 0;
  }

  .el-table .cell {
    max-height: 69px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
</style>
